import { render, staticRenderFns } from "./uninjuryStandard.vue?vue&type=template&id=79839a84&scoped=true"
import script from "./uninjuryStandard.vue?vue&type=script&lang=js"
export * from "./uninjuryStandard.vue?vue&type=script&lang=js"
import style0 from "./uninjuryStandard.vue?vue&type=style&index=0&id=79839a84&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79839a84",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('79839a84')) {
      api.createRecord('79839a84', component.options)
    } else {
      api.reload('79839a84', component.options)
    }
    module.hot.accept("./uninjuryStandard.vue?vue&type=template&id=79839a84&scoped=true", function () {
      api.rerender('79839a84', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sai/noaccident/uninjuryStandard.vue"
export default component.exports